import React, {useState} from 'react';
//components
import View from '../rich-text-editor-wrapper/rich-text-editor-wrapper-view';

const RichTextEditorWrapperContainer = (props) => {
  const [editText, setEditText] = useState(false);
  const [text, setText] = useState(props.text);
  const [newText, setNewText] = useState('');

  React.useEffect(() => {
    if (!editText) {
      let elements = document.getElementsByClassName('ql-toolbar')
      if(elements.length > 0) {
        elements[0].remove()
      }
    }
  }, [editText]);

  const save = () => {
    if (newText !== '') {
      setText(newText)
      props.emitText(newText)
    } else {
      setText()
      props.emitText()
    }
    setEditText(false)
  };

  return (
    <View
      displayEdit={props.displayEdit}
      text={text}
      editText={editText}
      setNewText={setNewText}
      setEditText={setEditText}
      emptyText={props.emptytext}
      save={save}
    />
  );
};

export default RichTextEditorWrapperContainer;